import {
  sendCreativeEngagementEvent,
  sendCreativeTrackingEvents
} from './TrackAnalyticsHelper';

export type OCSTrackingEvent = 'loaded' | 'engagement';

export function sendOCSTrackingEvent(event: string, parameters?: object) {
  // remove OCS_ prefix
  const ocsEvent: OCSTrackingEvent = event
    .slice('OCS_'.length, event.length)
    .toLowerCase() as OCSTrackingEvent;

  if (ocsEvent === 'engagement') {
    sendCreativeEngagementEvent();
    return;
  }
  sendCreativeTrackingEvents(ocsEvent, parameters);

  OcsEventDispatcher.getInstance().notify(ocsEvent);
}

export class OcsEventDispatcher {
  private static instance: OcsEventDispatcher;

  public static getInstance(): OcsEventDispatcher {
    if (!OcsEventDispatcher.instance) {
      OcsEventDispatcher.instance = new OcsEventDispatcher();
    }

    return OcsEventDispatcher.instance;
  }

  private eventListeners: {
    [ocsEvent: string]: Function[];
  } = {};

  public addEventListener(event: OCSTrackingEvent, cb: () => void): void {
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }

    this.eventListeners[event].push(cb);
  }

  public notify(event: OCSTrackingEvent): void {
    (this.eventListeners[event] || []).forEach(cb => {
      cb();
    });
  }
}
